import { render, staticRenderFns } from "./modelLoading.modal.vue?vue&type=template&id=72330c57&scoped=true"
import script from "./modelLoading.modal.vue?vue&type=script&lang=js"
export * from "./modelLoading.modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72330c57",
  null
  
)

export default component.exports